<template>
<div class="gate-design">
  <b-input
    :label="isTapmixer() ? 'Gate title' : 'Campaign title'"
    :value="page.title"
    @input="page.title = $event"
    :max="150"
    :req="true"
    :show-validate-icons="true"
    :error="this.$v.page.title.$error"
    :v="this.$v.page.title"
  />
  <b-input
    inp-type="textarea"
    :label="isTapmixer() ? 'Gate description' : 'Campaign description'"
    :max="250"
    :value="page.description"
    :req="true"
    @input="page.description = $event"
    :error="this.$v.page.description.$error"
    :v="this.$v.page.description"
    :show-validate-icons="true"
    />
  <upload-image ref="uploadImage" @cover="coverUpload" :uploadedImg="page.cover" />
  <div class="gate-design-options" :class="{'flex-column': isFanfrick()}">
    <dropdown
      :options="buttons"
      label="Unlock button text"
      :selected="selected.button"
      @on-change="$emit('change-button', $event)"/>
    <dropdown
      v-if="isTapmixer()"
      :options="colorScheme"
      label="Design schema"
      :selected="selected.colorScheme"
      @on-change="$emit('change-scheme', $event)" />
  </div>
  <BDatepicker
      type="secondary"
      label="Start date"
      :disabled="!subscriptionLimitNotExceeded"
      :datepicker-type="'date'"
      :datepicker-format="'YYYY-MM-DD'"
      :disabledBefore="$moment(new Date(Date.now()-86400000))"
      :date="dateStart"
      :default-value="dateStart ? dateStart : new Date()"
      @on-change="changeStartDate"
  />
  <BDatepicker
      type="secondary"
      :datepicker-type="'date'"
      label="End date"
      :disabled="!subscriptionLimitNotExceeded"
      :datepicker-format="'YYYY-MM-DD'"
      :default-value="dateStart ?
        $moment(new Date(dateStart)) :
        $moment(new Date())"
      :disabledBefore="dateStart ?
        $moment(new Date(dateStart)) :
        $moment(new Date())"
      :date="dateEnd"
      @on-change="dateEnd = $event"
  />
  <div v-if="!subscriptionLimitNotExceeded" class="date-pickers-info">
    <div class="date-pickers-info-title">
      <div class="icon">
        <i style="color: #666; margin-right: 8px" class="fak fa-circle-info-light"/>
      </div>
      <div class="text">
        <p>You have reached the limit on the number of simultaneously enabled campaigns that correspond
          to your plan, so delayed enabling/disabling of campaigns is not yet available. Please disable
          some campaigns or <router-link to="/pricing">upgrade</router-link> your subscription.</p>
      </div>
    </div>
  </div>
</div>
</template>
<script>
import Vue from 'vue'

import BInput from "@/components/__new_ui_kit/Input/BInput";
import {required, maxLength} from "vuelidate/lib/validators";
import UploadImage from "@/components/UploadImage/UploadImage.vue";
import Dropdown from "@/components/__new_ui_kit/Dropdown/Dropdown";
import BDatepicker from "@/components/__new_ui_kit/Datepicker/BDatepicker";
import {mapGetters} from "vuex";

export default Vue.extend({
  data() {
    return {
      buttons: [
        {value: 1, label: 'Reward related'},
        {value: 2, label: 'Get reward'},
      ],
      colorScheme: [
        {value: 1, label: 'Light scheme', _value: false},
        {value: 2, label: 'Dark scheme', _value: true}
      ],
      dateStart: null,
      dateEnd: null
    }
  },
  components: {
    BDatepicker,
    Dropdown,
    BInput,
    UploadImage
  },
  props: {
    page: {
      type: Object
    },
    selected: {
      type: Object
    }
  },
  validations: {
    page: {
      title: {
        required,
        maxLength: maxLength(150)
      },
      description: {
        required,
        maxLength: maxLength(250)
      }
    }
  },
  methods: {
    coverUpload(data) {
      this.$emit('cover', data)
    },
    changeStartDate(event) {
      this.dateStart = event
      if (!!this.dateEnd && this.$moment(event) > this.$moment(this.dateEnd)) {
        this.dateEnd = null
      }
    }
  },
  computed: {
    ...mapGetters(['userInfo']),
    subscriptionLimitNotExceeded() {
      const subscriptionInfo = this.userInfo.subscription_info;
      const activeSubscription = subscriptionInfo?.active_subscription;

      if (activeSubscription) {
        if (this.page.active) {
          return true
        } else {
          return this.userInfo.active_content_count < activeSubscription.campaign_limit
        }
      }
      return false;
    },
  },
  mounted() {
    if (this.$route.params?.id) {
      this.$v.$touch()
    }
    if (!!this.page.turn_on_gate_at) {
      this.dateStart = new Date(this.$moment(this.page.turn_on_gate_at*1000).format('YYYY-MM-DD HH:mm:ss'))
    }
    if (!!this.page.turn_off_gate_at) {
      this.dateEnd = new Date(this.$moment(this.page.turn_off_gate_at*1000).format('YYYY-MM-DD HH:mm:ss'))
    }
  },
  watch: {
    '$v.$invalid'(value) {
      this.$emit('error-handle', 'gate-design', value)
    },
    dateStart(v) {
      this.$emit('change-start-date', v ? this.$moment(v).format('YYYY-MM-DD HH:mm:ss') : null)
      this.$emit('change-start-date-timestamp', v ? this.$moment(v).unix() : null)
    },
    dateEnd(v) {
      this.$emit('change-end-date', v ? this.$moment(v).format('YYYY-MM-DD HH:mm:ss') : null)
      this.$emit('change-end-date-timestamp', v ? this.$moment(this.$moment(v).format('YYYY-MM-DD HH:mm:ss')).unix() : null)
    }
  }
})
</script>
<style lang="scss" scoped>;
.date-pickers {
  &-info {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    margin-bottom: 20px;
    gap: 6px;
    &-title {
      display: flex;
      align-items: flex-start;
      p {
        margin-top: 3px;
        font-size: 14px;
        font-weight: 400;
        line-height: 20px;
      }
    }
    &-body {
      ul {
        li {
          margin-top: 3px;
          font-size: 14px;
          font-weight: 400;
          line-height: 20px;
        }
      }
    }
  }
}
.gate-design {
  padding-left: 16px;
  display: flex;
  flex-direction: column;
  gap: 20px;
  &-options {
    display: flex;
    gap: 12px;
    justify-content: space-between;
    @media (max-width: 740px) {
      flex-wrap: wrap;
    }
    > div {
      width: 100%;
    }
  }
}
</style>